<template>
  <div class="SiteApp">
    <div class="image-wrapper">
      <AppThumbnail
        :image-url="app.thumbnail_url || app.icon_url || defaultIcon"
        :alt="app.name"
        :fallback-text="app.name"
        :show-fallback-text="false"
        class="app-thumbnail"
      />
      <div class="forge-native-tag">
        <the-icon icon="logo-small" width="16" height="16" class="mr-1" />
        Forge app
      </div>
    </div>
    <div class="pa-5">
      <div class="d-flex justify-space-between items-center">
        <div class="app-name">
          {{ app.name }}
        </div>
        <v-menu offset-x>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text icon compact v-on="on">
              <the-icon icon="more-vert" />
            </v-btn>
          </template>
          <v-list dark class="the-app-bar__dropdown">
            <v-list-item v-if="app.documentation_url">
              <v-list-item-title class="SiteApp__action" @click="openDocs">
                <span class="SiteApp__icon">
                  <v-icon>exit_to_app</v-icon>
                </span>
                Documentation
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title class="SiteApp__action" @click="getSupport">
                <span class="SiteApp__icon">
                  <v-icon>help</v-icon>
                </span>
                Get Support
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
      <div class="mt-3 app-tag-wrapper">
        <span class="tag" v-for="categoryName in categoryNames" :key="categoryName">
          {{ categoryName }}
        </span>
      </div>
      <div class="app-description my-5">{{ app.description }}</div>
      <div class="d-flex justify-space-between align-center">
        <v-btn
          @click="install()"
          large
          dark
          color="y1"
        >
          <the-icon
            class="mr-2"
            color="y1"
            fill="y1"
            icon="download"
          />
          Install
        </v-btn>
        <div class="d-flex align-center">
          <the-icon
            class="mr-2"
            color="y1"
            icon="download"
            width="16"
            height="16"
          />
          {{ app.installed_count || 0 }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MODAL_ALERT } from '@/components/Modals'
import AppThumbnail from './AppThumbnail.vue'

export default {
  name: 'SiteAppsForgeAppAvailable',
  components: {
    AppThumbnail
  },
  props: {
    app: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      activeSite: (state) => state.sites.active,
    }),
    categoryNames() {
      return this.app?.category ? [this.app.category.charAt(0).toUpperCase() + this.app.category.slice(1)] : []
    },
    defaultIcon() {
      // Return a default icon if none is provided - use the same default as other apps
      return require('@/components/TheSite/SiteApps/tempPics/chisel-app.jpg')
    }
  },
  methods: {
    openDocs() {
      if (this.app?.documentation_url) {
        window.open(this.app.documentation_url, '_blank')
      }
    },
    install() {
      if (!this.app?.id || !this.activeSite?.id) {
        this.$root.$emit('showSnack', {
          message: 'Unable to install app - missing data',
          color: 'error'
        })
        return
      }
      
      this.$store.commit('application/openModal', {
        component: MODAL_ALERT,
        props: {
          title: 'App installation',
          text: `You are going to install ${this.app.name}. Are you sure?`,
          actionBtnLabel: 'Install',
          showCancelBtn: true,
          action: async () => {
            try {
              await this.$store.dispatch('forgeApps/installApp', {
                appId: this.app.id,
                siteId: this.activeSite.id,
                config: {}
              })
              this.$emit('app-changed')
              this.$root.$emit('showSnack', {
                message: `${this.app.name} installed successfully`,
                color: 'success'
              })
            } catch (error) {
              this.$root.$emit('showSnack', {
                message: `Failed to install ${this.app.name}`,
                color: 'error'
              })
            }
          },
        },
      })
    },
    getSupport() {
      window.open(
        'https://community.beach.io/t/forge-apps-wishlist-feedback/36',
        '_blank'
      )
    },
  },
}
</script>

<style scoped lang="scss">
$style: SiteApp;
.#{$style} {
  border: 1px solid $N6;
  border-radius: 8px;
  background: $N7;
  .app-name {
    font-size: 16px;
  }
}
.#{$style}__icon {
  width: 30px;
  text-align: center;
  .v-icon.v-icon {
    font-size: 20px;
  }
}
.#{$style}__action {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  &.dangerous {
    color: $Y1;
  }
}
.image-wrapper {
  position: relative;
  margin-bottom: 5px;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}
.forge-native-tag {
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 6px;
  padding: 4px 6px;
  background: $B5;
  display: flex;
  align-items: center;
  z-index: 1;
}
.app-description {
  min-height: 60px;
  white-space: pre-line;
}
.app-tag-wrapper {
  min-height: 32px;
  margin-bottom: 5px;
}
span.tag {
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 400;
  border-radius: 6px;
  margin-right: 8px;
  background: $N5;
  margin-bottom: 5px;
  display: inline-block;
}
.app_type {
  display: inline-block;
  padding: 4px 8px;
  font-size: 11px;
  font-weight: 400;
  border-radius: 6px;
  background: $N5;
  margin-bottom: 5px;
}
</style> 